import AdministrationContent from './AdministrationContent'

export default AdministrationContent
